var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileWhiteTransparent({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68.001,
    height: 40.002,
    viewBox: "0 0 68.001 40.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mobile",
    transform: "translate(-858 -724.999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons8-iphone_x",
    transform: "translate(930 729) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_4",
    "data-name": "Subtraction 4",
    d: "M-12376-8879h-16a4.006,4.006,0,0,1-4-4v-32a4.006,4.006,0,0,1,4-4h16a4.006,4.006,0,0,1,4,4v32A4.006,4.006,0,0,1-12376-8879Zm-16-38a2,2,0,0,0-2,2v32a2,2,0,0,0,2,2h16a2,2,0,0,0,2-2v-32a2,2,0,0,0-2-2h-1a1,1,0,0,0-1,1,2,2,0,0,1-2,2h-8a2,2,0,0,1-2-2,1,1,0,0,0-1-1Z",
    transform: "translate(12408 8923)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "icons8-android_os",
    transform: "translate(10.834 38.64) rotate(-90)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1854",
    "data-name": "Path 1854",
    d: "M9.622,22.46A.811.811,0,0,1,8,22.46V18.811a.811.811,0,0,1,1.622,0Zm11.354,0a.811.811,0,0,1-1.622,0V18.811a.811.811,0,0,1,1.622,0Zm-7.3,4.46a.811.811,0,0,1-1.622,0V23.271a.811.811,0,1,1,1.622,0Zm3.244,0a.811.811,0,0,1-1.622,0V23.271a.811.811,0,1,1,1.622,0Z",
    transform: "translate(0 -7.175)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1855",
    "data-name": "Path 1855",
    d: "M14,12.055v6.082a.813.813,0,0,0,.811.811H21.3a.813.813,0,0,0,.811-.811V12.055ZM18.055,8C15.622,8,14.122,9.46,14,11.244h8.11C21.988,9.46,20.488,8,18.055,8Zm-1.622,2.271a.405.405,0,1,1,.405-.405A.406.406,0,0,1,16.433,10.271Zm3.244,0a.405.405,0,1,1,.405-.405A.406.406,0,0,1,19.677,10.271Z",
    transform: "translate(-3.567 -1.23)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1856",
    "data-name": "Path 1856",
    d: "M21.6,7.784a.576.576,0,0,1-.243-.081.4.4,0,0,1-.122-.568l.689-1.014a.411.411,0,1,1,.689.446l-.689,1.014A.321.321,0,0,1,21.6,7.784Zm-3.649-.162a.361.361,0,0,1-.324-.2L17.1,6.567a.411.411,0,0,1,.689-.446l.527.852a.4.4,0,0,1-.122.568A.576.576,0,0,1,17.951,7.622Z",
    transform: "translate(-5.369)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icons8-iphone_x-2",
    "data-name": "icons8-iphone_x",
    transform: "translate(846 721)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_3",
    "data-name": "Subtraction 3",
    d: "M-12359-8863h-16a4.006,4.006,0,0,1-4-4v-32a4.006,4.006,0,0,1,4-4h16a4,4,0,0,1,4,4v32A4,4,0,0,1-12359-8863Zm-16-38a2,2,0,0,0-2,2v32a2,2,0,0,0,2,2h16a2,2,0,0,0,2-2v-32a2,2,0,0,0-2-2h-1a1,1,0,0,0-1,1,2,2,0,0,1-2,2h-8a2,2,0,0,1-2-2,1,1,0,0,0-1-1Z",
    transform: "translate(12391 8907)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1853",
    "data-name": "Path 1853",
    d: "M30,27.539a9.272,9.272,0,0,1-.907,1.578c-.589.832-1.42,1.875-2.45,1.883-.913.006-1.147-.555-2.389-.547s-1.5.555-2.415.547c-1.029-.008-1.814-.945-2.405-1.781-1.646-2.337-1.82-5.078-.8-6.535a3.7,3.7,0,0,1,2.934-1.641c1.089,0,1.775.559,2.676.559.875,0,1.407-.559,2.67-.559a3.644,3.644,0,0,1,2.681,1.317A2.784,2.784,0,0,0,30,27.539Zm-3.733-7.516A2.489,2.489,0,0,0,26.973,18a3.633,3.633,0,0,0-2.216,1.023A2.319,2.319,0,0,0,24.034,21,3.069,3.069,0,0,0,26.267,20.023Z",
    fill: "#fff",
    opacity: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileWhiteTransparent);
export default __webpack_public_path__ + "static/media/mobile_white-transparent.1096afc25d4c75c7ca665baf6efdd25c.svg";
export { ForwardRef as ReactComponent };